import { useEffect } from 'react'
import Router from 'next/router'

export function useCloseOnRouteChange(isOpen, setIsOpen) {
  useEffect(() => {
    if (!isOpen) return

    function handleRouteChange() {
      setIsOpen(false)
    }

    Router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [isOpen])
}
